import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "copyright py-4 text-center text-white" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createTextVNode("Built on "),
  /*#__PURE__*/_createElementVNode("i", { class: "fab fa-fw fa-vuejs" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", null, "Copyright © honzapilar.cz 2020 - " + _toDisplayString($data.year), 1),
      _hoisted_3,
      _hoisted_4
    ])
  ]))
}